<template>
  <v-card elevation="0" v-if="value && languageData">
    <v-col class="col-12" style="padding-top: 0 !important; padding-bottom: 0 !important; padding-right: 0 !important">
    <v-list>
      <v-list-item v-if="!value.total_gross"> 
        <v-list-item-content style="padding-top: 0 !important; padding-bottom: 0 !important">
            <table class="estimate-table estimate-table--main" style="border-radius: 5px; background-color: #FFA400; color: #fff">
              <tbody>
                <tr>
                  <td width="15%"> 
                      {{ value.number }}
                  </td>
                  <td width="auto">
                      {{ value.name }}
                  </td>
                  <td width="auto">
                      {{ value.description }}
                  </td>
                </tr>
              </tbody>
            </table>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="value.total_gross"> 
          <v-list-item-content style="background-color: #fde8bf; border-radius: 5px padding-top: 0 !important; padding-bottom: 0 !important">
              <table class="estimate-table estimate-table--main">
                <tbody>
                  <tr>
                    <td width="15%">
                        {{ value.number }}
                    </td>
                    <td width="auto">
                        {{ value.name }}
                    </td>
                    <td width="auto">
                        {{ value.description }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="mt-2 estimate-table">
                  <thead style="background-color: #f1f1f1">
                    <tr v-if="languageData.labels">
                      <td>
                          {{ languageData.labels.uom }}
                      </td>
                      <td>
                          {{ languageData.labels.price }}
                      </td>
                      <td>
                          {{ languageData.labels.quantity }}
                      </td>
                      <td v-if="showVat && value.visibleInput && value.vat">
                          {{ languageData.labels.vat }}
                      </td>
                      <td>
                          {{ languageData.labels.net_value }}
                      </td>
                      <td>
                          {{ languageData.labels.gross_value }}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td v-if="languageData.measureTypes">
                          {{ languageData.measureTypes[value.uom.value] }}
                      </td>
                      <td>
                          {{ value.price }}
                      </td>
                      <td>
                          {{ value.quantity }}
                      </td>
                      <td v-if="showVat && value.visibleInput && value.vat">
                          {{ typeof value.vat === 'number' ? value.vat + '%' : languageData.vatLabels[value.vat.label] }}
                      </td>
                      <td>
                          {{ value.total_net }}
                      </td>
                      <td>
                          {{ value.total_gross }}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </v-list-item-content>
      </v-list-item>
      <EstimatePreviewList
        v-for="(child, index) in value.children"
        :key="value.children[index].id"
        v-model="value.children[index]"
        :level="level + 1"
        :disabled="level < 1"
        :showVat="showVat"
    ></EstimatePreviewList>
    </v-list>
    </v-col>
  </v-card>
</template>

<script>
import EstimatePreviewList from "./EstimatePreview.vue";

export default {
  name: "EstimatePreviewList",
  props: {
    value: Object,
    level: Number,
    showVat: [Boolean, String],
  },
  components: {
    EstimatePreviewList,
  },
}
</script>
